import _ from 'lodash'

// const updateObjectProperty = (array, key, prop, newProp) => {
//   const isFind = array.findIndex(item => item[key] === prop)
//   if (isFind !== -1) {
//     array.splice(isFind, 1, { key: newProp, prop: 'value' })
//   }
// }

import { updateObjectProperty, deepCopyArray, groupBy } from '@/helper'

const WorldMapModule = {
  namespaced: true,
  state: {
    data: [],
    m: {}
  },
  mutations: {
  	async set_world_map_data (state, payload) {
      state.m = {
        country_id: '',
        year: Math.max(...payload.map(item => item.year))
      }
      state.data = payload
      console.log('set_world_map_data', state.m)
      return Promise.resolve(true)
    },
    set_router (state, router) {
      state.router = router
    }
  },
  getters: {
  	model (state, getters, rootState) {
      return state.m
    },
    data (state) {
      return state.data
    },
    years: (state, getters, rootState) => () => {
      return [...new Set(getters.data.map(item => item.year))]
    },
    filterProps: (state, getters) => {
      return _.pickBy(getters.model, (v) => (v && v.length !== 0 && v))
    },
    filtered (state, getters) {
      return getters.data
        .filter(obj => 
          Object.entries(getters.filterProps)
            .every(([prop, find]) => Array.isArray(find) ? find.includes(obj[prop]) : find === obj[prop])
        )
    },
    mapData (state, getters, rootState, rootGetters) {
      // console.log('filtered', getters.filtered)
      // console.log('filters', rootGetters['PageModule/categorySetting']().worldMap.filters)
      // console.log('key', rootGetters['PageModule/categorySetting']().aditionalFilter.model.type)
      // console.log('1919', rootGetters['PageModule/categorySetting']().worldMap.filters)

      const categorySetting = rootGetters['PageModule/categorySetting']()
      const filters = updateObjectProperty(
        deepCopyArray(categorySetting.worldMap.filters),
        'key', 
        '', 
        categorySetting.aditionalFilter?.model.type
      )
      const data = getters.filtered.map(item => filters.reduce((acumu, k) => Object.assign(acumu, { [k.prop]: item[k.key] }), {}))      
      return data
    },
    hightchartData (state, getters) {
      return groupBy(deepCopyArray(getters.mapData))
    }
  },
  actions: {
    async initWorldMapData ({ dispatch, commit, state, rootState, getters }, payload) {
      return await commit('set_world_map_data', payload)
    }
  }
}

export default WorldMapModule

